import { useCallback } from 'react';
import { useTranslation } from '@testsigma/atoms';

import {
  MetadataConnectionModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';

import { getSalesforceEditionI18nKey } from '@modules/salesforce/models';

import { getConnectionEnv } from '@modules/salesforce/utils/utils';

const useConnectionSuccessful = () => {
  const { t } = useTranslation();

  const {
    selectedConnection,
    handleUpdateOverlayMode,
    handleUpdateMetadataConnectionModalScreen,
    handleReload,
  } = useSFConnectionState();

  const handleDone = useCallback(() => {
    handleUpdateOverlayMode('none');
    handleReload();
  }, [handleUpdateOverlayMode, handleReload]);

  const handleGoBack = useCallback(() => {
    handleUpdateMetadataConnectionModalScreen(
      MetadataConnectionModalScreens.CONNECTION_CREATE_SCREEN,
    );
  }, [handleUpdateMetadataConnectionModalScreen]);

  const getEnvironmentInfo = () => {
    const textContent = `${t(
      getSalesforceEditionI18nKey(getConnectionEnv(selectedConnection)),
    )} / ${selectedConnection?.environmentName}`;
    return `
      <span class='!text-secondary-1000'>
        ${textContent}
      </span>
    `;
  };

  return {
    handleDone,
    handleGoBack,
    getEnvironmentInfo,
  };
};

export { useConnectionSuccessful };
